import * as React from "react";
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState, } from "react";
import { focusManager } from "../utils/Focus";
import { ExitConfirmModal } from "../components/views/modals/ExitConfirmModal";
var ExitModalContext = createContext(null);
// Any other modal already on screen: InfoModal renders `.modal-container`,
// overlay-based modals render `.modal-overlay`. Don't stack the exit modal
// on top of either.
var otherModalOpen = function () {
    return !!document.querySelector(".modal-container, .modal-overlay");
};
export var ExitModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    // Imperative source of truth so rapid key presses can't double-trigger
    // within the same tick (state updates are async).
    var openRef = useRef(false);
    var openExitModal = useCallback(function () {
        if (openRef.current || otherModalOpen())
            return false;
        openRef.current = true;
        focusManager.pushLayer({ groupName: "exitModal", index: 0 });
        setOpen(true);
        return true;
    }, []);
    var closeExitModal = useCallback(function () {
        if (!openRef.current)
            return;
        focusManager.popLayer();
        openRef.current = false;
        setOpen(false);
    }, []);
    var handleExit = useCallback(function () {
        window.close();
    }, []);
    var isExitModalOpen = useCallback(function () { return openRef.current; }, []);
    useEffect(function () {
        var handleKeyDown = function (e) {
            if (!focusManager.isKey(e.keyCode, "EXIT"))
                return;
            if (openExitModal()) {
                e.preventDefault();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
            if (openRef.current) {
                focusManager.popLayer();
                openRef.current = false;
            }
        };
    }, [openExitModal]);
    var value = useMemo(function () { return ({ openExitModal: openExitModal, isExitModalOpen: isExitModalOpen, otherModalOpen: otherModalOpen }); }, [openExitModal, isExitModalOpen]);
    return (React.createElement(ExitModalContext.Provider, { value: value },
        children,
        open && (React.createElement("div", { id: "exit-modal-overlay", tabIndex: 0, className: "modal-overlay", key: "exit-confirm-modal" },
            React.createElement(ExitConfirmModal, { onClose: closeExitModal, onExit: handleExit })))));
};
export var useExitModal = function () {
    var context = useContext(ExitModalContext);
    if (!context) {
        throw new Error("useExitModal must be used within ExitModalProvider");
    }
    return context;
};



//////////////////
// WEBPACK FOOTER
// ./src/context/ExitModalContext.tsx
// module id = 37
// module chunks = 1